import { Injectable } from '@angular/core';
import { Cart } from '../../../libs/proto/shop_pb';
import { BinaryWriter } from 'google-protobuf';

@Injectable({
  providedIn: 'root'
})
export class CartConversionService {

  constructor() { }

  ToStorage(req: Cart) {
    const w = new BinaryWriter();
    Cart.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (c: Cart, errorConvert: any) => void) {
    try {
      callback( Cart.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
}
